module.exports = __webpack_public_path__ + "img/get-btn.628ef917.png";